import { render, staticRenderFns } from "./SpeakerIcon.vue?vue&type=template&id=dde11234&scoped=true&"
import script from "./SpeakerIcon.vue?vue&type=script&lang=ts&"
export * from "./SpeakerIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SpeakerIcon.vue?vue&type=style&index=0&id=dde11234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde11234",
  null
  
)

export default component.exports